import React from 'react';
import { faVolume } from '@fortawesome/pro-regular-svg-icons/faVolume';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface VolumeRegularIconProps {
  className?: string;
  styleName?: string;
}

function VolumeRegularIcon(props: VolumeRegularIconProps) {
  return <FontAwesomeIcon icon={faVolume} {...props} />;
}

export default VolumeRegularIcon;
